<template>
  <div class="col-12 text-left mt-3">
    <div class="form-group mb-3">
      <label>{{ computedTitle }}</label>
      <div class="progress d-flex flex-column" style="height: 52px; border-radius: 12px !important; background-color: transparent !important; border: 1px solid #89898995; overflow: hidden; position: relative;">
        <!-- Barra superior: Valor 1 (e.g. Vida Útil) -->
        <div class="w-100 d-flex" :style="{ height: hasValor2 ? '50%' : '100%' }">
          <div 
            class="progress-bar progress-bar-animated font-weight-bold d-flex align-items-center justify-content-center" 
            role="progressbar" 
            :style="{ width: tiempoVidaPorcentaje + '%', 'clip-path': (!hasValor2 || tiempoVidaPorcentaje === 100) ? 'none' : 'polygon(0 0, 100% 0, calc(100% - 10px) 100%, 0 100%)', '-webkit-clip-path': (!hasValor2 || tiempoVidaPorcentaje === 100) ? 'none' : 'polygon(0 0, 100% 0, calc(100% - 10px) 100%, 0 100%)' }" 
            :class="progressBarClass"
            :aria-valuenow="tiempoVidaPorcentaje" 
            aria-valuemin="0" 
            aria-valuemax="100"
            style="font-size: 0.75rem; height: 100%; transition: width 0.6s ease; border-radius: 0;"
          >
            <span class="px-2" v-if="tiempoVidaPorcentaje > 5"> {{ tiempoVidaPorcentaje }}%</span>
          </div>
        </div>
        
        <!-- Barra inferior: Valor 2 (e.g. Garantía) -->
        <div class="w-100 d-flex" style="height: 50%;" v-if="hasValor2">
          <div 
            class="progress-bar progress-bar-animated font-weight-bold d-flex align-items-center justify-content-center" 
            role="progressbar" 
            :style="{ width: tiempoGarantiaPorcentaje + '%', 'clip-path': tiempoGarantiaPorcentaje === 100 ? 'none' : 'polygon(0 0, 100% 0, calc(100% - 10px) 100%, 0 100%)', '-webkit-clip-path': tiempoGarantiaPorcentaje === 100 ? 'none' : 'polygon(0 0, 100% 0, calc(100% - 10px) 100%, 0 100%)' }" 
            :class="progressBarGarantiaClass"
            :aria-valuenow="tiempoGarantiaPorcentaje" 
            aria-valuemin="0" 
            aria-valuemax="100"
            style="font-size: 0.75rem; height: 100%; transition: width 0.6s ease; border-radius: 0;"
          >
            <span class="px-2" v-if="tiempoGarantiaPorcentaje > 5">{{ tiempoGarantiaPorcentaje }}%</span>
            <span class="px-2 text-muted" v-else style="font-size: 0.7rem;">Sin {{ label2 }}</span>
          </div>
        </div>
        <div class="shadow_inset_sm" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; border-radius: 12px !important;"></div>
      </div>
      
      <div class="row mt-3 mx-0">
        <!-- Card 1: Valor 1 (e.g. Vida Útil) -->
        <div :class="hasValor2 ? 'col-12 col-lg-6 pl-0 pr-0 pr-lg-1 mb-2 mb-lg-0' : 'col-12 px-0'">
          <div class="py-2 px-3 shadow_inset_sm h-100" style="border-radius: 15px !important; background-color: #f8f9fa; display: flex; flex-direction: column; justify-content: center; min-height: 72px; transition: all .5s !important;">
            <div class="d-flex align-items-center justify-content-between w-100">
              <!-- Left Side: Large Muted Percentage -->
              <div class="font-weight-bold text-muted mr-2 text-secondary" style="font-size: 2rem; line-height: 1; min-width: 50px; text-align: left; color: #aeaeae !important; font-family: Arial, Helvetica, sans-serif; flex-shrink: 0; font-weight: 700!important;">
                {{ displayVidaPorcentaje }}%
              </div>
              <!-- Right Side: Text & Detail & Dot grouped together -->
              <div class="d-flex align-items-center justify-content-end text-right">
                <div style="text-align: right !important; margin-right: 8px;">
                  <div class="text-muted font-weight-bold" style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; text-align: right !important;">
                    {{ computedLabel1 }}
                  </div>
                  <div class="text-dark font-weight-bold" style="font-size: 0.8rem; line-height: 1.3; text-align: right !important;">
                    {{ tiempoVidaDetalle }}
                  </div>
                </div>
                <!-- Dot -->
                <div class="d-flex align-items-center flex-shrink-0">
                  <span :class="dotVidaClass" style="width: 10px; height: 10px; border-radius: 50%; display: inline-block; box-shadow: 0 0 3px rgba(0,0,0,0.2);"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Card 2: Valor 2 (e.g. Garantía) -->
        <div class="col-12 col-lg-6 pr-0 pl-0 pl-lg-1" v-if="hasValor2">
          <div class="py-2 px-3 shadow_inset_sm h-100" style="border-radius: 15px !important; background-color: #f8f9fa; display: flex; flex-direction: column; justify-content: center; min-height: 72px; transition: all .5s !important;">
            <div class="d-flex align-items-center justify-content-between w-100">
              <!-- Left Side: Large Muted Percentage -->
              <div class="font-weight-bold text-muted mr-2" style="font-size: 2rem; line-height: 1; min-width: 50px; text-align: left; color: #aeaeae !important; font-family: Arial, Helvetica, sans-serif; flex-shrink: 0; font-weight: 700!important;">
                <span>{{ displayGarantiaPorcentaje }}%</span>
              </div>
              <!-- Right Side: Text & Detail & Dot grouped together -->
              <div class="d-flex align-items-center justify-content-end text-right">
                <div style="text-align: right !important; margin-right: 8px;">
                  <div class="text-muted font-weight-bold" style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; text-align: right !important;">
                    {{ computedLabel2 }}
                  </div>
                  <div class="text-dark font-weight-bold" style="font-size: 0.8rem; line-height: 1.3; text-align: right !important;">
                    {{ tiempoGarantiaDetalle }}
                  </div>
                </div>
                <!-- Dot -->
                <div class="d-flex align-items-center flex-shrink-0">
                  <span :class="dotGarantiaClass" style="width: 10px; height: 10px; border-radius: 50%; display: inline-block; box-shadow: 0 0 3px rgba(0,0,0,0.2);"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * TimeProgressBarProvider
 * 
 * Componente genérico para representar barras de progreso temporales dobles (ej. Vida Útil y Garantía)
 * con cortes diagonales (clip-path), animación progresiva de porcentaje y formato detallado de tiempo transcurrido o restante.
 * 
 * PROPS:
 * - fechaCompra (fecha-compra): Fecha de inicio/compra (ej. "YYYY-MM-DD") para iniciar el cálculo.
 * - valor1: Duración en meses para el primer indicador (ej. Vida Útil). Requerido.
 * - valor2: Duración en meses para el segundo indicador (ej. Garantía). Opcional. Si es null/undefined se oculta.
 * - label1: Nombre descriptivo para el indicador 1. Por defecto "Vida Útil".
 * - label2: Nombre descriptivo para el indicador 2. Por defecto "Garantía".
 * - title: Título superior principal. Si se omite, se autogenera según los labels y el sort.
 * - sort: Dirección del progreso ("ASC" para barra llenándose/tiempo transcurrido, "DESC" para vaciándose/tiempo restante).
 */
export default {
  name: "TimeProgressBarProvider",
  props: {
    // Fecha base sobre la cual se calcula el tiempo transcurrido (compra/inicio)
    fechaCompra: {
      type: String,
      default: ""
    },
    // Duración total en meses para el primer indicador (ej. Vida Útil en meses)
    valor1: {
      type: [Number, String],
      default: null
    },
    // Duración total en meses para el segundo indicador (ej. Garantía en meses)
    valor2: {
      type: [Number, String],
      default: null
    },
    // Nombre para mostrar en el indicador principal (ej. "Vida Útil")
    label1: {
      type: String,
      default: "Valor Comparativo 1"
    },
    // Nombre para mostrar en el indicador secundario (ej. "Garantía")
    label2: {
      type: String,
      default: "Valor Comparativo 2"
    },
    // Título opcional superior. Si viene vacío se autogenera dinámicamente
    title: {
      type: String,
      default: ""
    },
    // Sentido del progreso: 'ASC' (llenándose / transcurrido) o 'DESC' (vaciándose / restante)
    sort: {
      type: String,
      default: "DESC",
      validator: (val) => ["ASC", "DESC"].includes(val.toUpperCase())
    }
  },
  data() {
    return {
      // Porcentajes interpolados localmente para la animación de count-up (0% -> target%)
      displayVidaPorcentaje: 0,
      displayGarantiaPorcentaje: 0
    };
  },
  computed: {
    // Retorna true si hay un valor2 válido y mayor a 0
    hasValor2() {
      if (this.valor2 === undefined || this.valor2 === null || this.valor2 === '') {
        return false;
      }
      const val2 = parseFloat(this.valor2);
      return !isNaN(val2) && val2 > 0;
    },
    // Retorna true si el progreso decrementa (DESC / Restante)
    isDesc() {
      return this.sort.toUpperCase() === "DESC";
    },
    computedTitle() {
      if (this.title) return this.title;
      const suffix = this.isDesc ? "Restante" : "Transcurrido";
      if (this.hasValor2) {
        return `${this.label1} & ${this.label2} ${suffix}`;
      }
      return `${this.label1} ${suffix}`;
    },
    computedLabel1() {
      const suffix = this.isDesc ? "Restante" : "Transcurrida";
      return `${this.label1} ${suffix}`;
    },
    computedLabel2() {
      const suffix = this.isDesc ? "Restante" : "Transcurrida";
      return `${this.label2} ${suffix}`;
    },
    tiempoVidaPorcentaje() {
      if (!this.fechaCompra || !this.valor1) {
        return 0;
      }
      const val1 = parseFloat(this.valor1);
      if (isNaN(val1) || val1 <= 0) {
        return 0;
      }
      const formats = ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD", "YYYY-MM-DDTHH:mm:ssZ", "YYYY-MM-DD HH:mm:ss"];
      const fechaCompra = moment(this.fechaCompra, formats);
      if (!fechaCompra.isValid()) {
        return 0;
      }
      const hoy = moment();
      if (fechaCompra.isAfter(hoy)) {
        return this.isDesc ? 100 : 0;
      }
      const totalMonths = val1;
      const elapsedMonths = Math.max(hoy.diff(fechaCompra, 'months', true), 0);
      const porcentaje = Math.min((elapsedMonths / totalMonths) * 100, 100);
      const displayVal = this.isDesc ? (100 - porcentaje) : porcentaje;
      return Math.min(Math.max(Math.round(displayVal), 0), 100);
    },
    progressBarClass() {
      const pct = this.tiempoVidaPorcentaje;
      if (this.isDesc) {
        if (pct > 50) {
          return 'bg-success';
        } else if (pct > 15) {
          return 'bg-warning text-dark';
        } else {
          return 'bg-danger text-white';
        }
      } else {
        if (pct < 50) {
          return 'bg-success';
        } else if (pct < 85) {
          return 'bg-warning text-dark';
        } else {
          return 'bg-danger text-white';
        }
      }
    },
    tiempoVidaDetalle() {
      if (!this.fechaCompra || !this.valor1) {
        return `Ingrese la fecha y ${this.label1} para calcular.`;
      }
      const val1 = parseFloat(this.valor1);
      if (isNaN(val1) || val1 <= 0) {
        return `${this.label1} inválido.`;
      }
      const formats = ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD", "YYYY-MM-DDTHH:mm:ssZ", "YYYY-MM-DD HH:mm:ss"];
      const fechaCompra = moment(this.fechaCompra, formats);
      if (!fechaCompra.isValid()) {
        return "Fecha inválida.";
      }
      const hoy = moment();
      if (fechaCompra.isAfter(hoy)) {
        return "La fecha de inicio está en el futuro.";
      }

      const totalMonths = val1;
      const fechaLimite = fechaCompra.clone().add(totalMonths, 'months');

      let detailText = ``;

      if (this.isDesc) {
        // Cuenta regresiva / Restante
        if (hoy.isBefore(fechaLimite)) {
          const tempHoy = hoy.clone();
          const diffMonths = fechaLimite.diff(tempHoy, 'months');

          if (diffMonths >= 12) {
            const remainingYears = Math.floor(diffMonths / 12);
            tempHoy.add(remainingYears, 'years');
            const remainingMonths = fechaLimite.diff(tempHoy, 'months');
            tempHoy.add(remainingMonths, 'months');
            const remainingDays = fechaLimite.diff(tempHoy, 'days');

            detailText += `${remainingYears} año(s), ${remainingMonths} mes(es) y ${remainingDays} día(s)`;
          } else {
            const remainingMonths = diffMonths;
            tempHoy.add(remainingMonths, 'months');
            const remainingDays = fechaLimite.diff(tempHoy, 'days');

            detailText += `${remainingMonths} mes(es) y ${remainingDays} día(s)`;
          }
        } else {
          detailText += `Finalizado / Expirado.`;
        }
      } else {
        // Transcurrido
        const targetDate = hoy.isBefore(fechaLimite) ? hoy : fechaLimite;
        const diffMonths = targetDate.diff(fechaCompra, 'months');

        if (diffMonths >= 12) {
          const elapsedYears = Math.floor(diffMonths / 12);
          const tempStart = fechaCompra.clone().add(elapsedYears, 'years');
          const elapsedMonths = targetDate.diff(tempStart, 'months');
          const tempMonths = tempStart.add(elapsedMonths, 'months');
          const elapsedDays = targetDate.diff(tempMonths, 'days');

          detailText += `${elapsedYears} año(s), ${elapsedMonths} mes(es) y ${elapsedDays} día(s) transcurrido(s)`;
        } else {
          const elapsedMonths = diffMonths;
          const tempMonths = fechaCompra.clone().add(elapsedMonths, 'months');
          const elapsedDays = targetDate.diff(tempMonths, 'days');

          detailText += `${elapsedMonths} mes(es) y ${elapsedDays} día(s) transcurrido(s)`;
        }

        if (hoy.isAfter(fechaLimite) || hoy.isSame(fechaLimite)) {
          detailText += ` (Totalmente transcurrido)`;
        }
      }

      return detailText;
    },
    tiempoGarantiaPorcentaje() {
      if (!this.fechaCompra || !this.valor2) {
        return 0;
      }
      const val2 = parseFloat(this.valor2);
      if (isNaN(val2) || val2 <= 0) {
        return 0;
      }
      const formats = ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD", "YYYY-MM-DDTHH:mm:ssZ", "YYYY-MM-DD HH:mm:ss"];
      const fechaCompra = moment(this.fechaCompra, formats);
      if (!fechaCompra.isValid()) {
        return 0;
      }
      const hoy = moment();
      if (fechaCompra.isAfter(hoy)) {
        return this.isDesc ? 100 : 0;
      }
      const elapsedMonths = Math.max(hoy.diff(fechaCompra, 'months', true), 0);
      const porcentaje = Math.min((elapsedMonths / val2) * 100, 100);
      const displayVal = this.isDesc ? (100 - porcentaje) : porcentaje;
      return Math.min(Math.max(Math.round(displayVal), 0), 100);
    },
    progressBarGarantiaClass() {
      if (!this.valor2 || parseFloat(this.valor2) <= 0) {
        return 'bg-secondary text-white';
      }
      const pct = this.tiempoGarantiaPorcentaje;
      if (this.isDesc) {
        if (pct === 0) {
          return 'bg-secondary text-white';
        } else if (pct > 50) {
          return 'bg-info text-white';
        } else {
          return 'bg-warning text-dark';
        }
      } else {
        if (pct === 100) {
          return 'bg-secondary text-white';
        } else if (pct < 50) {
          return 'bg-info text-white';
        } else {
          return 'bg-warning text-dark';
        }
      }
    },
    tiempoGarantiaDetalle() {
      if (!this.fechaCompra || !this.valor2) {
        return `Sin ${this.label2} registrada o fecha inválida.`;
      }
      const val2 = parseFloat(this.valor2);
      if (isNaN(val2) || val2 <= 0) {
        return `Sin ${this.label2} registrada.`;
      }
      const formats = ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD", "YYYY-MM-DDTHH:mm:ssZ", "YYYY-MM-DD HH:mm:ss"];
      const fechaCompra = moment(this.fechaCompra, formats);
      if (!fechaCompra.isValid()) {
        return "Fecha inválida.";
      }
      const hoy = moment();
      const fechaLimiteGarantia = fechaCompra.clone().add(val2, 'months');

      let detailText = ``;

      if (this.isDesc) {
        if (hoy.isBefore(fechaLimiteGarantia)) {
          const tempHoy = hoy.clone();
          const diffMonths = fechaLimiteGarantia.diff(tempHoy, 'months');

          if (diffMonths >= 12) {
            const remainingYears = Math.floor(diffMonths / 12);
            tempHoy.add(remainingYears, 'years');
            const remainingMonths = fechaLimiteGarantia.diff(tempHoy, 'months');
            tempHoy.add(remainingMonths, 'months');
            const remainingDays = fechaLimiteGarantia.diff(tempHoy, 'days');

            detailText += `${remainingYears} año(s), ${remainingMonths} mes(es) y ${remainingDays} día(s) restante(s)`;
          } else {
            const remainingMonths = diffMonths;
            tempHoy.add(remainingMonths, 'months');
            const remainingDays = fechaLimiteGarantia.diff(tempHoy, 'days');

            detailText += `${remainingMonths} mes(es) y ${remainingDays} día(s) restante(s)`;
          }
        } else {
          detailText += `Vencida / Expirada.`;
        }
      } else {
        const targetDate = hoy.isBefore(fechaLimiteGarantia) ? hoy : fechaLimiteGarantia;
        const diffMonths = targetDate.diff(fechaCompra, 'months');

        if (diffMonths >= 12) {
          const elapsedYears = Math.floor(diffMonths / 12);
          const tempStart = fechaCompra.clone().add(elapsedYears, 'years');
          const elapsedMonths = targetDate.diff(tempStart, 'months');
          const tempMonths = tempStart.add(elapsedMonths, 'months');
          const elapsedDays = targetDate.diff(tempMonths, 'days');

          detailText += `${elapsedYears} año(s), ${elapsedMonths} mes(es) y ${elapsedDays} día(s) transcurrido(s)`;
        } else {
          const elapsedMonths = diffMonths;
          const tempMonths = fechaCompra.clone().add(elapsedMonths, 'months');
          const elapsedDays = targetDate.diff(tempMonths, 'days');

          detailText += `${elapsedMonths} mes(es) y ${elapsedDays} día(s) transcurrido(s)`;
        }

        if (hoy.isAfter(fechaLimiteGarantia) || hoy.isSame(fechaLimiteGarantia)) {
          detailText += ` (Vencida)`;
        }
      }

      return detailText;
    },
    dotVidaClass() {
      const pct = this.tiempoVidaPorcentaje;
      if (this.isDesc) {
        if (pct > 50) {
          return 'bg-success';
        } else if (pct > 15) {
          return 'bg-warning';
        } else {
          return 'bg-danger';
        }
      } else {
        if (pct < 50) {
          return 'bg-success';
        } else if (pct < 85) {
          return 'bg-warning';
        } else {
          return 'bg-danger';
        }
      }
    },
    dotGarantiaClass() {
      if (!this.valor2 || parseFloat(this.valor2) <= 0) {
        return 'bg-secondary';
      }
      const pct = this.tiempoGarantiaPorcentaje;
      if (this.isDesc) {
        if (pct === 0) {
          return 'bg-secondary';
        } else if (pct > 50) {
          return 'bg-info';
        } else {
          return 'bg-warning';
        }
      } else {
        if (pct === 100) {
          return 'bg-secondary';
        } else if (pct < 50) {
          return 'bg-info';
        } else {
          return 'bg-warning';
        }
      }
    }
  },
  watch: {
    tiempoVidaPorcentaje: {
      immediate: true,
      handler(newVal) {
        this.animateVida(newVal);
      }
    },
    tiempoGarantiaPorcentaje: {
      immediate: true,
      handler(newVal) {
        this.animateGarantia(newVal);
      }
    }
  },
  methods: {
    animateVida(target) {
      let self = this;
      let start = self.displayVidaPorcentaje || 0;
      let duration = 800; // 800ms
      let steps = 40;
      let stepTime = duration / steps;
      let currentStep = 0;
      
      if (self.vidaInterval) {
        clearInterval(self.vidaInterval);
      }
      
      self.vidaInterval = setInterval(() => {
        currentStep++;
        let progress = currentStep / steps;
        let ease = progress * (2 - progress); // easeOutQuad
        self.displayVidaPorcentaje = Math.round(start + (target - start) * ease);
        if (currentStep >= steps) {
          self.displayVidaPorcentaje = Math.round(target);
          clearInterval(self.vidaInterval);
        }
      }, stepTime);
    },
    animateGarantia(target) {
      let self = this;
      let start = self.displayGarantiaPorcentaje || 0;
      let duration = 800;
      let steps = 40;
      let stepTime = duration / steps;
      let currentStep = 0;
      
      if (self.garantiaInterval) {
        clearInterval(self.garantiaInterval);
      }
      
      self.garantiaInterval = setInterval(() => {
        currentStep++;
        let progress = currentStep / steps;
        let ease = progress * (2 - progress);
        self.displayGarantiaPorcentaje = Math.round(start + (target - start) * ease);
        if (currentStep >= steps) {
          self.displayGarantiaPorcentaje = Math.round(target);
          clearInterval(self.garantiaInterval);
        }
      }, stepTime);
    }
  }
};
</script>
